<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 600px; max-width: 90vw;">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Select Location</div>
        <q-space />
        <q-btn icon="close" flat round dense @click="$emit('update:modelValue', false)" />
      </q-card-section>

      <q-card-section>
        <div class="text-caption text-grey-7 q-mb-md">
          Select the physical location where this device is installed
        </div>

        <!-- Location Tree -->
        <q-tree
          :nodes="locationTreeNodes"
          node-key="id"
          selected-color="primary"
          :selected="selectedLocationNode"
          default-expand-all
          class="location-tree"
          @update:selected="$emit('update:selected-location', $event)"
        >
          <template #default-header="prop">
            <div class="row items-center">
              <q-icon
                :name="prop.node.icon"
                :color="prop.node.selectable ? 'primary' : 'grey-6'"
                size="20px"
                class="q-mr-sm"
              />
              <div>
                <div class="text-weight-medium">{{ prop.node.label }}</div>
                <div v-if="prop.node.description" class="text-caption text-grey-7">
                  {{ prop.node.description }}
                </div>
              </div>
            </div>
          </template>
        </q-tree>

        <!-- Selected Location Display -->
        <div v-if="selectedLocationForPicker" class="q-mt-md q-pa-sm bg-blue-1 rounded-borders">
          <div class="text-caption text-grey-7">Selected Location:</div>
          <div class="text-weight-medium">{{ selectedLocationLabel }}</div>
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" @click="$emit('update:modelValue', false)" />
        <q-btn
          color="primary"
          label="Select"
          :disable="!selectedLocationForPicker"
          @click="$emit('confirm-selection')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
    locationTreeNodes: {
      type: Array,
      required: true,
    },
    selectedLocationNode: {
      type: String,
      default: null,
    },
    selectedLocationForPicker: {
      type: Object,
      default: null,
    },
    selectedLocationLabel: {
      type: String,
      default: '',
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:selected-location',
    'confirm-selection',
  ]);
</script>
